/**
 * Counts the visible characters inside a WYSIWYG editor value, ignoring markup.
 *
 * WYSIWYG editors store their value as HTML, so a naive `.length` also counts
 * tags, link hrefs and entities. Use this when a character limit should reflect
 * only what the user actually sees in the editor.
 */
export const getRichTextLength = (html?: string): number => {
  if (!html) return 0;
  if (typeof document !== 'undefined') {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || '').length;
  }
  return html.replace(/<[^>]*>/g, '').length;
};
